export default {
      id: "oc-icon_next-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_next",
      toString: function () {
        return this.url;
      }
    }